import { Routes } from '@angular/router';
import { adminAuthGuard } from './guards/admin-auth.guard';
import { adminRoleGuard } from './guards/admin-role.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((module) => module.LoginPage)
  },
  {
    path: 'setup',
    loadComponent: () =>
      import('./pages/login/login.page').then((module) => module.LoginPage)
  },
  {
    path: 'admin/setup',
    loadComponent: () =>
      import('./pages/login/login.page').then((module) => module.LoginPage)
  },
  {
    path: '',
    canActivate: [adminAuthGuard],
    loadComponent: () =>
      import('./layouts/admin-shell/admin-shell.component').then((module) => module.AdminShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/home/home.page').then((module) => module.HomePage)
      },
      {
        path: 'general',
        canActivate: [adminRoleGuard],
        data: { roles: ['OPS'] },
        loadComponent: () =>
          import('./pages/general/general.page').then((module) => module.GeneralPage)
      },
      {
        path: 'metrics',
        canActivate: [adminRoleGuard],
        data: { roles: ['OPS', 'DEVELOPER'] },
        loadComponent: () =>
          import('./pages/metrics/metrics.page').then((module) => module.MetricsPageComponent)
      },
      {
        path: 'moderation',
        canActivate: [adminRoleGuard],
        data: { roles: ['OPS'] },
        loadComponent: () =>
          import('./pages/moderation/moderation.page').then((module) => module.ModerationPageComponent)
      },
      {
        path: 'trends',
        canActivate: [adminRoleGuard],
        data: { roles: ['OPS'] },
        loadComponent: () =>
          import('./pages/trends/trends.page').then((module) => module.TrendsPage)
      },
      {
        path: 'last-generations',
        canActivate: [adminRoleGuard],
        data: { roles: ['OPS'] },
        loadComponent: () =>
          import('./pages/last-generations/last-generations.page').then((module) => module.LastGenerationsPage)
      },
      {
        path: 'shared-images',
        canActivate: [adminRoleGuard],
        data: { roles: ['OPS'] },
        loadComponent: () =>
          import('./pages/shared-images/shared-images.page').then((module) => module.SharedImagesPage)
      },
      {
        path: 'feedback',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPPORT'] },
        loadComponent: () =>
          import('./pages/feedback/feedback.page').then((module) => module.FeedbackPageComponent)
      },
      {
        path: 'feedback/:id',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPPORT'] },
        loadComponent: () =>
          import('./pages/feedback/components/feedback-detail-view/feedback-detail-view.component').then((module) => module.FeedbackDetailViewComponent)
      },
      {
        path: 'credits',
        canActivate: [adminRoleGuard],
        data: { roles: ['CONTENT', 'OPS'] },
        loadComponent: () =>
          import('./pages/credits/credits.page').then((module) => module.CreditsPage)
      },
      {
        path: 'products',
        canActivate: [adminRoleGuard],
        data: { roles: ['CONTENT'] },
        loadComponent: () =>
          import('./pages/products/products.page').then((module) => module.ProductsPage)
      },
      {
        path: 'settings',
        canActivate: [adminRoleGuard],
        data: { roles: ['DEVELOPER'] },
        loadComponent: () =>
          import('./pages/settings/settings.page').then((module) => module.SettingsPage)
      },
      {
        path: 'invites',
        canActivate: [adminRoleGuard],
        data: { roles: ['OPS', 'SUPER_ADMIN'] },
        loadComponent: () =>
          import('./pages/invite-management/invite-management.component').then((module) => module.InviteManagementComponent)
      },
      {
        path: 'users',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN'] },
        loadComponent: () =>
          import('./pages/users/users.page').then((module) => module.AdminUsersPage)
      },
      {
        path: 'platform-users',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN'] },
        loadComponent: () =>
          import('./pages/platform-users/platform-users.page').then((module) => module.PlatformUsersPage)
      },
      {
        path: 'email-test',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN'] },
        loadComponent: () =>
          import('./pages/email-test/email-test.component').then((module) => module.EmailTestComponent)
      },
      {
        path: 'unauthorized',
        loadComponent: () =>
          import('./pages/unauthorized/unauthorized.page').then((module) => module.UnauthorizedPage)
      },
      {
        path: 'support',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPPORT'] },
        loadComponent: () =>
          import('./pages/support/support.page').then((module) => module.SupportPageComponent)
      },
      {
        path: 'banners',
        canActivate: [adminRoleGuard],
        data: { roles: ['CONTENT', 'SUPER_ADMIN'] },
        loadComponent: () =>
          import('./pages/banners/banners.page').then((module) => module.BannersPage)
      },
      {
        path: 'blog',
        canActivate: [adminRoleGuard],
        data: { roles: ['CONTENT', 'SUPER_ADMIN'] },
        loadComponent: () =>
          import('./pages/blog/blog.page').then((module) => module.BlogPage)
      },
      {
        path: 'notifications',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN', 'SUPPORT'] },
        loadComponent: () =>
          import('./pages/notification-sender/notification-sender.page').then((module) => module.NotificationSenderPage)
      },
      {
        path: 'director-debug',
        canActivate: [adminRoleGuard],
        data: { roles: ['DEVELOPER'] },
        loadComponent: () =>
          import('./pages/director-debug/director-debug.page').then((module) => module.DirectorDebugPageComponent)
      },
      {
        path: 'style-registry',
        canActivate: [adminRoleGuard],
        data: { roles: ['CONTENT'] },
        loadComponent: () =>
          import('./pages/style-registry/style-registry.component').then((module) => module.StyleRegistryComponent)
      },
      {
        path: 'style-artists',
        canActivate: [adminRoleGuard],
        data: { roles: ['CONTENT'] },
        loadComponent: () =>
          import('./pages/style-artists/style-artists.page').then((module) => module.StyleArtistsPage)
      },
      {
        path: 'style-registry/edit/:type/:key',
        canActivate: [adminRoleGuard],
        data: { roles: ['CONTENT'] },
        loadComponent: () =>
          import('./pages/style-registry/style-editor.component').then((module) => module.StyleEditorComponent)
      },
      {
        path: 'integrity',
        canActivate: [adminRoleGuard],
        data: { roles: ['DEVELOPER'] },
        loadComponent: () =>
          import('./pages/integrity-check/integrity-check.component').then((module) => module.IntegrityCheckComponent)
      },
      {
        path: 'fleet',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN', 'OPS', 'DEVELOPER'] },
        loadComponent: () =>
          import('./pages/fleet/fleet.component').then((module) => module.FleetPageComponent)
      },
      {
        path: 'fleet/nodes/:clientId',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN', 'OPS', 'DEVELOPER'] },
        loadComponent: () =>
          import('./pages/fleet/node-details/node-details.page').then((module) => module.NodeDetailsPage)
      },
      {
        path: 'fleet/models',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN', 'OPS', 'DEVELOPER'] },
        loadComponent: () =>
          import('./pages/fleet/model-manager/model-manager.page').then((module) => module.ModelManagerPage)
      },
      {
        path: 'fleet/cleanup',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN', 'OPS'] },
        loadComponent: () =>
          import('./pages/fleet/temp-cleanup/temp-cleanup.page').then((module) => module.TempCleanupPage)
      },
      {
        path: 'fleet/hosts',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN', 'OPS', 'DEVELOPER'] },
        loadComponent: () =>
          import('./pages/fleet/hosts-config/hosts-config.page').then((module) => module.HostsConfigPage)
      },
      {
        path: 'dlq',
        canActivate: [adminRoleGuard],
        data: { roles: ['SUPER_ADMIN', 'OPS'] },
        loadComponent: () =>
          import('./pages/dlq/dlq.component').then((module) => module.DlqPageComponent)
      },
      {
        path: '**',
        redirectTo: 'general'
      }
    ]
  }
];